module.exports = __webpack_public_path__ + "img/icons.08d75fdc.png";